import React, { createContext, useContext } from "react";
import { useParams } from "react-router-dom";
const PVContext = createContext();
export const usePVContext = () => useContext(PVContext);
function PVContextProvider({ children }) {
  const projectId = useParams();
  const [project, setProject] = React.useState({
    id: projectId.id,
    data: {},
  });
  const [currentTab, setCurrentTab] = React.useState(0);


  // React.useEffect(() => {
  //   const data = () => {
  //     if (getValues()?.revisions?.[0]) {
  //       const projData = getValues().revisions[0].data;
  //       return typeof projData === "string" ? JSON.parse(projData) : projData;
  //     }
  //   };
  //   if (!project.name) {
  //     const func = async () => {
  //       const res = await getProject({ projectId: project.id });
  //       setProject({ ...project, ...res, data: data() });
  //     };
  //     func();
  //   }
  //   // func();
  // }, [project, getValues]);

  // console.log({ project });

  return (
    <PVContext.Provider
      value={{
        currentTab,
        setCurrentTab,
        project,
        setProject,
      }}
    >
      {children}
    </PVContext.Provider>
  );
}

export { PVContextProvider, PVContext };
